import axios from './axios';
import { CollectionResult, LabelTask, LineupEntry } from './sessionModels';

const BATCH_SIZE = 10;
const SESSIONS = `${process.env.REACT_APP_PORTAL_URL}/api/v1/sessions`;
const LABEL_TASKS = `${SESSIONS}/label-tasks`;

export type LabelTaskInput = {
  startFrame: number;
  endFrame: number;
  startX: number;
  startY: number;
  startZ: number;
  classType: string;
  lineupEntryId?: number | null;
  ownerId?: number | null;
};

export const labelTaskInput = (task: LabelTask): LabelTaskInput => ({
  startFrame: task.startFrame,
  endFrame: task.endFrame,
  startX: task.startX,
  startY: task.startY,
  startZ: task.startZ,
  classType: task.classType || 'REFEREE',
  lineupEntryId: task.lineupEntry?.id ?? null,
  ownerId: task.owner?.id ?? null,
});

const labelTasks = {
  getLineup(sessionId: number | string): Promise<CollectionResult<LineupEntry>> {
    return axios.get(`${SESSIONS}/${sessionId}/lineup-entries`);
  },
  getLabelTask(id: number | string): Promise<LabelTask> {
    return axios.get(`${LABEL_TASKS}/${id}`);
  },
  getLabelTasks(sessionId: number | string): Promise<CollectionResult<LabelTask>> {
    return axios.get(LABEL_TASKS, { params: { sessionId } });
  },
  addLabelTask(sessionId: number | string, input: LabelTaskInput): Promise<LabelTask> {
    return axios.post(LABEL_TASKS, { ...input, sessionId: Number(sessionId) });
  },
  updateLabelTask(id: number, input: LabelTaskInput): Promise<LabelTask> {
    return axios.put(`${LABEL_TASKS}/${id}`, input);
  },
  changeOwner(id: number, ownerId: number | null): Promise<void> {
    return axios.put(`${LABEL_TASKS}/${id}/change-owner`, { ownerId });
  },
  deleteLabelTask(id: number): Promise<void> {
    return axios.delete(`${LABEL_TASKS}/${id}`);
  },
  async addLabelTasks(sessionId: number | string, inputs: LabelTaskInput[]) {
    for (let i = 0; i < inputs.length; i += BATCH_SIZE) {
      await Promise.all(inputs.slice(i, i + BATCH_SIZE).map((input) => labelTasks.addLabelTask(sessionId, input)));
    }
  },
  async clearLabelTasks(sessionId: number | string) {
    let { items } = await labelTasks.getLabelTasks(sessionId);
    while (items.length > 0) {
      for (let i = 0; i < items.length; i += BATCH_SIZE) {
        await Promise.all(items.slice(i, i + BATCH_SIZE).map((task) => labelTasks.deleteLabelTask(task.id)));
      }
      ({ items } = await labelTasks.getLabelTasks(sessionId));
    }
  },
};

export default labelTasks;
